import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { useSearchParams } from "react-router-dom";
import stl from "./TamweelForm.module.css";
import useHelpers from "@hooks/useHelpers";
var FinanceRejected = function FinanceRejected(_ref) {
  var haveanotherOrder = _ref.haveanotherOrder,
    _ref$customTitle = _ref.customTitle,
    customTitle = _ref$customTitle === void 0 ? null : _ref$customTitle,
    _ref$customText = _ref.customText,
    customText = _ref$customText === void 0 ? null : _ref$customText;
  var _useTranslation = useTranslation(["web_checkout_finance"]),
    t = _useTranslation.t;
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var postId = searchParams.get("post_id");
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: ["container", stl.container].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: [stl.form, stl.rejection].join(" ")
  }, /*#__PURE__*/React.createElement("i", {
    className: stl.ErrIcon
  }), /*#__PURE__*/React.createElement("h3", {
    className: stl.h3Tag
  }, (customTitle !== null && customTitle !== void 0 ? customTitle : haveanotherOrder == 1) ? t("active_request", {
    ns: "web_checkout_finance"
  }) : t("error_apologize_2", {
    ns: "web_checkout_finance"
  })), customText && /*#__PURE__*/React.createElement("p", {
    className: stl.pStyle
  }, customText), !customText && /*#__PURE__*/React.createElement("p", {
    className: stl.pStyle
  }, haveanotherOrder == 9 && t("request_available", {
    ns: "web_checkout_finance"
  }), haveanotherOrder == 1 && t("cannot_submit_new_request_until", {
    ns: "web_checkout_finance"
  }), haveanotherOrder == 2 && t("data_meet_bank_financing_requirements", {
    ns: "web_checkout_finance"
  })), haveanotherOrder != 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
    className: [stl.btn, "blueBtn"].join(" "),
    href: createUrl("/cardetail/" + postId)
  }, t("back_car_details", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("a", {
    className: [stl.btn, "whtBtn"].join(" "),
    href: createUrl("/")
  }, t("back_homepge", {
    ns: "web_checkout_finance"
  }))), haveanotherOrder == 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
    className: [stl.btn, "blueBtn"].join(" "),
    href: createUrl("/tracking-landing")
  }, t("track_car_order", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("a", {
    className: [stl.btn, "whtBtn"].join(" "),
    href: createUrl("/cardetail/" + postId)
  }, t("back_car_details", {
    ns: "web_checkout_finance"
  }))))));
};
export default FinanceRejected;